module.exports = __webpack_public_path__ + "static/intercom-integration6-6e96235cbbec68f9fcbfbd0c5d794cf4.png";